import { render, staticRenderFns } from "./ViewSwitch.vue?vue&type=template&id=52a4ac4f&"
import script from "./ViewSwitch.vue?vue&type=script&lang=js&"
export * from "./ViewSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports